import * as actions from "./actionsType";

const initialData = {
  loaderEmployeeMonitor: false,
  employeeMonitor: null,
  employeeMonitorFalla: null,
  saveLoaderEmployeeMonitor: false,
  employeeMonitorFormError: null,
};

export default function EmployeeMonitorCapacitationReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_EMPLOYEE_MONITOR:
      return { ...state, loaderEmployeeMonitor: action.payload };

    case actions.GET_EMPLOYEE_MONITOR:
      return { ...state, employeeMonitor: action.payload };

    case actions.EMPLOYEE_MONITOR_FALLA:
      return { ...state, employeeMonitorFalla: action.payload };

    case actions.SAVE_LOADER_EMPLOYEE_MONITOR:
      return { ...state, saveLoaderEmployeeMonitor: action.payload };

    case actions.FORM_EMPLOYEE_MONITOR_FAIL:
      return { ...state, employeeMonitorFormError: action.payload };

    default:
      return state;
  }
}
